import { FinancialAccount } from "@/types/types";
import Asset from "./Asset";

type Props = {
  lifeInsurances: {
    data: FinancialAccount[];
    title?: string;
    total?: number;
  }[];
};

export default function LifeInsurance({ lifeInsurances }: Props) {
  return (
    <div className="w-full rounded-md bg-neutral-500 p-8 sm:w-1/2">
      <span className="text-lg font-medium text-neutral-100">Life Insurance</span>
      <div className="mt-4 flex flex-col gap-6">
        {lifeInsurances.map(({ data, title, total }, i) => (
          <Asset key={i} accounts={data} title={title} isLifeInsurance assetsTotal={total ?? 0} />
        ))}
      </div>
    </div>
  );
}
